import React from "react";
import Dashboard from "../components/dashboard/Dashboard";
import Dashboard2 from "../components/dashboard/Dashboard2";
export function DashboardPage() {
  // return <Dashboard />;
  return <Dashboard2 />;
}
